import { Component } from 'react';

import ErrorBoundary from './ErrorBoundary';

interface IProps {
  component: React.ReactNode;
}

export default class ErrorBoundaryWrapper extends Component<IProps> {
  /**
   *
   */
  public render() {
    return <ErrorBoundary>{this.props.component}</ErrorBoundary>;
  }
}
